// Chakra imports
import { SimpleGrid, Text, useColorModeValue } from "@chakra-ui/react";
// Custom components
import Card from "components/card/Card.js";
import React from "react";
import Information from "views/admin/profile/components/Information";

// Assets
export default function GeneralInformation(props) {
  const { ...rest } = props;
  // Chakra Color Mode
  const textColorPrimary = useColorModeValue("secondaryGray.900", "white");
  const textColorSecondary = "gray.400";
  const cardShadow = useColorModeValue(
    "0px 18px 40px rgba(112, 144, 176, 0.12)",
    "unset"
  );
  return (
    <Card mb={{ base: "0px", "2xl": "20px" }} {...rest}>
      <Text
        color={textColorPrimary}
        fontWeight='bold'
        fontSize='2xl'
        mt='10px'
        mb='4px'>
        Des points réguliers
      </Text>
      <Text color={textColorSecondary} fontSize='md' me='26px' mb='30px'>
         Afin de vous offrir un suivi proactif, nous vous proposons des points réguliers tout le long du programme. Nous serions également ravis d'échanger avec vous à votre convenance.
      </Text>
      <SimpleGrid columns='2' gap='20px'>
        <Information
          boxShadow={cardShadow}
          title='Semaine 1'
          value='Webinaires Kick-Off'
        />
        <Information
          boxShadow={cardShadow}
          title='Semaine 8'
          value="Résultat parcours de mesure"
        />
        <Information
          boxShadow={cardShadow}
          title='Semaine 18'
          value='Feedback de mi-parcours'
        />
        <Information
          boxShadow={cardShadow}
          title='Semaine 28'
          value='Progression des managers'
        />
        <Information
          boxShadow={cardShadow}
          title='Semaine 36'
          value='Bilan du programme'
        />
      </SimpleGrid>
    </Card>
  );
}
